import { lazy, Suspense, useLayoutEffect, useState } from "react";

import { useLocation } from "react-router-dom";

import { environment, LABEL, siteURLs } from "../utils/constant";
import {
  CALENDER_EMAIL_UPDATE,
  GOOGLE_OAUTH_CALLBACK,
  KNOWLEDGE_SOURCE,
  MS_OAUTH_CALLBACK,
} from "../utils/APIEndPoints";
import { showToast } from "../helper/toastHelper";
import { CallAPI } from "../utils/apiActions";
import useAuth from "../hooks/useAuth";
import BotQnAPrompt from "../components/my-chatboat/BotQnAPrompt";
import SplashScreen from "../components/SplashScreen";

import BotAppearance from "../components/my-chatboat/BotAppearance";
import BotProcessingProgress from "../components/my-chatboat/BotProcessingProgress";
// import BotKnowledgeSource from "../components/my-chatboat/BotKnowledgeSource";
// import BotChatSettings from "../components/my-chatboat/BotChatSettings";
// import BotBuilder from "../components/my-chatboat/BotBuilder";

// const BotAppearance = lazy(
//   () => import("../components/my-chatboat/BotAppearance"),
// );
const BotKnowledgeSource = lazy(
  () => import("../components/my-chatboat/BotKnowledgeSource"),
);
const BotChatSettings = lazy(
  () => import("../components/my-chatboat/BotChatSettings"),
);
const BotBuilder = lazy(() => import("../components/my-chatboat/BotBuilder"));

const BotSettings = () => {
  const location = useLocation();
  const { user } = useAuth();
  const [tab, setTab] = useState(
    new URLSearchParams(location?.search).get("tab"),
  );
  const [botName, setBotName] = useState(
    new URLSearchParams(location?.search).get("botname"),
  );
  const botId = new URLSearchParams(location?.search).get("id") || null;
  const G_code = new URLSearchParams(location?.search).get("code") || null;
  const [finalStep, setFinalStep] = useState(0);

  useLayoutEffect(() => {
    if (!!G_code && localStorage.getItem("returnParams")) {
      handleGoogleAuthCallback();
    }
  }, [G_code]);

  const handleGoogleAuthCallback = async () => {
    let returnUrl = `${siteURLs[environment()]}${location.pathname}`;
    let forPlatform = JSON.parse(
      localStorage.getItem("autoSchedulingParams"),
    ).platform;
    let body = {
      code: G_code,
      user_id: user.userUuid,
      redirect_uri: returnUrl,
      user_email: JSON.parse(localStorage.getItem("autoSchedulingParams"))
        .calender_email,
      meeting_duration: JSON.parse(localStorage.getItem("autoSchedulingParams"))
        .meeting_duration,
      appointment_location: JSON.parse(
        localStorage.getItem("autoSchedulingParams"),
      ).appointment_location,
      appointment_type: JSON.parse(localStorage.getItem("autoSchedulingParams"))
        .appointment_type,
      bot_id: JSON.parse(localStorage.getItem("autoSchedulingParams")).bot_id,
    };
    const response = await CallAPI(
      "CHAT",
      "POST",
      forPlatform == "google" ? GOOGLE_OAUTH_CALLBACK : MS_OAUTH_CALLBACK,
      body,
    );
    if (response.status) {
      //   const url = new URL(window.location.href);
      //   url.searchParams.delete("code");

      //   window.history.replaceState({}, "", url.toString());
      let pageRedirectionFlag = false;
      if (
        JSON.parse(localStorage.getItem("autoSchedulingParams")).isNewEntery ==
        true
      ) {
        let body = {
          arr: [JSON.parse(localStorage.getItem("autoSchedulingParams")).arr],
          bot_id: JSON.parse(localStorage.getItem("autoSchedulingParams"))
            .bot_id,
          cate_id: 3,
          step: 2,
          type: "auto",
          calender_email: JSON.parse(
            localStorage.getItem("autoSchedulingParams"),
          ).calender_email,
          meeting_duration: JSON.parse(
            localStorage.getItem("autoSchedulingParams"),
          ).meeting_duration,
          appointment_location: JSON.parse(
            localStorage.getItem("autoSchedulingParams"),
          ).appointment_location,
          appointment_type: JSON.parse(
            localStorage.getItem("autoSchedulingParams"),
          ).appointment_type,
          platform: forPlatform,
        };
        const res = await CallAPI(
          "USER",
          "POST",
          KNOWLEDGE_SOURCE,
          body,
          false,
          false,
        );
        if (res.status) {
          pageRedirectionFlag = true;
          showToast(res.msg, LABEL.TOAST_TYPE.SUCCESS);
        } else {
          showToast(res.msg, LABEL.TOAST_TYPE.ERROR);
        }
      } else {
        let editedElement = JSON.parse(localStorage.getItem("editedElement"));
        let pythonBody = {
          bot_id: JSON.parse(localStorage.getItem("autoSchedulingParams"))
            .bot_id,
          prev_mail: editedElement.calender_email,
          new_mail: editedElement.slugs,
          platform: forPlatform,
          meeting_duration: JSON.parse(
            localStorage.getItem("autoSchedulingParams"),
          ).meeting_duration,
          appointment_location: JSON.parse(
            localStorage.getItem("autoSchedulingParams"),
          ).appointment_location,
          appointment_type: JSON.parse(
            localStorage.getItem("autoSchedulingParams"),
          ).appointment_type,
        };
        let response = await CallAPI(
          "CHAT",
          "PUT",
          CALENDER_EMAIL_UPDATE,
          pythonBody,
        );
        if (response.status) {
          let body = {
            ...editedElement,
            arr: [],
            bot_id: JSON.parse(localStorage.getItem("autoSchedulingParams"))
              .bot_id,
            ks_id: editedElement.ks_id,
            cate_id: 3,
            step: 2,
            name: editedElement.source_name,
            link: JSON.parse(localStorage.getItem("autoSchedulingParams"))
              .calender_email,
            calender_email: JSON.parse(
              localStorage.getItem("autoSchedulingParams"),
            ).calender_email,
            meeting_duration: JSON.parse(
              localStorage.getItem("autoSchedulingParams"),
            ).meeting_duration,
            appointment_location: JSON.parse(
              localStorage.getItem("autoSchedulingParams"),
            ).appointment_location,
            appointment_type: JSON.parse(
              localStorage.getItem("autoSchedulingParams"),
            ).appointment_type,
            slugs: undefined,
          };

          const res = await CallAPI("USER", "PUT", KNOWLEDGE_SOURCE, body);
          if (res.status) {
            pageRedirectionFlag = true;
            showToast(res.msg, LABEL.TOAST_TYPE.SUCCESS);
          } else {
            showToast(res.msg, LABEL.TOAST_TYPE.ERROR);
          }
        }
      }
      if (pageRedirectionFlag == true) {
        handleReturnFromGauth();
      }
    } else {
      handleReturnFromGauth();
    }

    // const url = new URL(window.location.href);
    // url.searchParams.delete("state");
    // url.searchParams.delete("code");
    // url.searchParams.delete("scope");
    // window.history.replaceState({}, document.title, url.pathname + url.search);
  };

  const handleReturnFromGauth = () => {
    window.location.href = `${siteURLs[environment()]}${
      location.pathname
    }?${localStorage.getItem("returnParams")}`;
    localStorage.removeItem("returnParams");
    localStorage.removeItem("autoSchedulingParams");
  };

  const handleSetTab = (selectedTab, botname, temp) => {
    if (botname) {
      setBotName(botname);
    }
    // if (finalStep + 1 >= parseInt(selectedTab)) {
    setTab(selectedTab);
    const url = new URL(window.location);
    url.searchParams.set("tab", selectedTab); // Set 'tab' to 2
    temp && url.searchParams.set("temp", temp);
    window.history.pushState({}, "", url);
    // }
  };

  // console.log("finalStep--", finalStep, botName);

  return (
    <div>
      <div className="mychatbot-grid">
        <header className="">
          <h3>{botName || ""}</h3>
        </header>

        <div className="tabs-grid">
          <ul className="tab-lists">
            <li className={tab == "1" ? "active" : ""}>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSetTab("1");
                }}
              >
                Appearance
              </a>
            </li>
            <li
              className={
                tab == "2" ? "active" : finalStep >= 1 ? "" : "inactive"
              }
            >
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSetTab("2");
                }}
              >
                Knowledge Sources
              </a>
            </li>
            <li
              className={
                tab == "3" ? "active" : finalStep >= 2 ? "" : "inactive"
              }
            >
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSetTab("3");
                }}
              >
                Q&A
              </a>
            </li>
            <li
              className={
                tab == "4" ? "active" : finalStep >= 3 ? "" : "inactive"
              }
            >
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSetTab("4");
                }}
              >
                Question Area
              </a>
            </li>
            <li
              className={
                tab == "5" ? "active" : finalStep >= 4 ? "" : "inactive"
              }
            >
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSetTab("5");
                }}
              >
                Chat Settings
              </a>
            </li>
          </ul>
          {tab == "1" && (
            <Suspense fallback={<SplashScreen />}>
              <BotAppearance
                handleSetTab={handleSetTab}
                setFinalStep={setFinalStep}
              />
            </Suspense>
          )}
          {tab == "2" && (
            <Suspense fallback={<SplashScreen />}>
              <BotKnowledgeSource
                handleSetTab={handleSetTab}
                setFinalStep={setFinalStep}
                finalStep={finalStep}
              />
            </Suspense>
          )}
          {tab == "3" && (
            <Suspense fallback={<SplashScreen />}>
              <BotQnAPrompt
                handleSetTab={handleSetTab}
                setFinalStep={setFinalStep}
                finalStep={finalStep}
              />
            </Suspense>
          )}
          {tab == "4" && (
            <Suspense fallback={<SplashScreen />}>
              <BotBuilder
                handleSetTab={handleSetTab}
                setFinalStep={setFinalStep}
                finalStep={finalStep}
              />
            </Suspense>
          )}
          {tab == "5" && (
            <Suspense fallback={<SplashScreen />}>
              <BotChatSettings
                handleSetTab={handleSetTab}
                setFinalStep={setFinalStep}
                finalStep={finalStep}
              />
            </Suspense>
          )}
        </div>
      </div>

      <BotProcessingProgress botId={botId} />
    </div>
  );
};

export default BotSettings;
